import { Button, EmailPhoneInput, Form } from '@chain-zen/ui'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

export const emailPhoneInputSchema = z.object({
  cleanedEmailPhone: z.string().optional(),
  countryCode: z.string().optional(),
  emailOrPhone: z
    .string()
    .min(1, 'Email or phone number is required')
    .refine(
      (value) => {
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
        const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/
        return emailRegex.test(value) || phoneRegex.test(value)
      },
      { message: 'Please enter a valid email or phone number' }
    )
})

interface EmailPhoneFormProps {
  initialValue: string
  loading: boolean
  onSubmit: (data: z.infer<typeof emailPhoneInputSchema>) => void
}

/** 
 * This component is used to send an invitation to a user by email or phone number.
    It uses the memberInvitationSchema to validate the input.
*/

export const EmailPhoneForm = ({ onSubmit, loading, initialValue }: EmailPhoneFormProps) => {
  const form = useForm<z.infer<typeof emailPhoneInputSchema>>({
    defaultValues: {
      emailOrPhone: initialValue
    },
    resolver: zodResolver(emailPhoneInputSchema)
  })

  return (
    <div className="w-auto">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          <EmailPhoneInput
            name="emailOrPhone"
            placeholder="Email or phone number..."
            data-testid="email-phone-input"
            className="max-w-md w-full"
          />
          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? 'Sending invitation...' : 'Send invitation'}
          </Button>
        </form>
      </Form>
    </div>
  )
}
